import { useDispatch } from "react-redux";

import { get_transactions } from "../api";
import { transactionsSelector } from "../selectors";
import { set_transactions_action } from "../actions";
import useReduxSwr from "../../global/hooks/useReduxSwr";

export default useTransactionsList;

function useTransactionsList() {
  let dispatch = useDispatch();
  let { data, isValidating, error } = useReduxSwr({
    fetcher: get_transactions,
    selector: transactionsSelector,
    onFinished: (data) => {
      // Workaround/Note: Server doesn't support for sorting, so we do it in client
      let transactions = Array.isArray(data) ? data.reverse() : data;
      dispatch(set_transactions_action(transactions));
    },
  });

  return {
    data,
    error: error,
    isValidating,
  };
}
